const Q1P1a = [
  {
    text: "Routine review of existing merchant / partner",
    type: "check"
  },
  {
    text: "Review as a result of trigger event – Please indicate the trigger event:",
    type: "notes"
  },
  {
    text: "Please provide details regarding the nature of services required by client:",
    type: "notes"
  }
];

const Q1P1b = [
  {
    text: "Referred merchant / partner / partner – Please indicate source of referral below:",
    type: "notes"
  },
  {
    text: "Please provide details regarding the nature of services required by client:",
    type: "notes"
  }
];

const Q1P2 = [
  {
    text: "For new merchant / partner, up-to-date and relevant identification information, including information on shareholders and directors, has been obtained as per Main Merchant App Form. Please skip 2 and proceed to 3.",
    type: "check"
  },
  {
    text: "For existing merchant / partner, information previously obtained for the purposes of client identification can be re-verified. ",
    type: "check"
  },
  {
    text: "No country / cross border restrictions and regulations on business activities / products / services offered by merchant/partner (i.e., Merchant / partner operates in a sanctioned country).",
    type: "check"
  },
  {
    text: "Merchant / partner and connected persons (beneficial owners, directors, shareholders, etc.) DO NOT MATCH with individuals or entities listed in terrorism-related sanctions, proliferation financing watchlists, or other high-risk databases, including but not limited to those under the Terrorism (Suppression of Financing) Act, the United Nations sanctions list, and MAS-designated lists.",
    type: "check"
  },
  {
    text: "The ownership of the merchant / partner and requested information from the merchant / partner can be verified (i.e., comparing information based on documents). ",
    type: "check"
  },
  {
    text: "The merchant / partner is cooperative and willing to furnish the required information required to facilitate application and KYC process.",
    type: "check"
  },
  {
    text: "There is no anonymity by the merchant / partner / beneficial owners / directors in the initial establishment of business contact and relationship.",
    type: "check"
  },
];

export {
  Q1P1a,
  Q1P1b,
  Q1P2
};